export default ({
  isAuthenticated ({ to, next, store }) {
    if ('email' in store.state.user.me) return next()
    // console.log('not has me')
    if (!('access' in store.state.user.auth)) {
      // console.log('not has auth')
      store.dispatch('user/checkAuth')
    }
    // console.log(store.state.user.auth)
    if (('access' in store.state.user.auth)) {
      return store.dispatch('user/getMe')
        .then(() => {
          return next()
        })
        .catch(() => {
          return next({ path: '/login', query: { to: to.path } })
        })
    }
    return next({ path: '/login', query: { to: to.path } })
  }
})
